<template>
  <div class="ivu-row-flex-end ivu-row-flex" style="margin-left: -12px;margin-right: -12px;">
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="订单号">
            <Input v-model="formItem.OrderID" placeholder="请输入订单号..."></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;"
          class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24"
          v-if="Role !== '销售员'">
      <FormItem :label-width="80" label="是否分配">
            <!-- <Input v-model="formItem.isAssign" placeholder="请输入..."></Input> -->
            <Select v-model="formItem.isAssign" clearable value="formItem.isAssign">
                <Option value="是">是</Option>
                <Option value="否">否</Option>
              </Select>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="订单状态">
            <Select v-model="formItem.State"  value="formItem.State" placeholder="请选择订单状态..." clearable>
                <Option value="预付款待确认">预付款待确认</Option>
                <Option value="预付款已确认">预付款已确认</Option>
                <Option value="尾款待确认">尾款待确认</Option>
                <Option value="全额待确认">全额待确认</Option>
                <Option value="全额已确认">全额已确认</Option>
                <Option value="订单作废">订单作废</Option>
            </Select>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="客户名称">
            <Input v-model="formItem.Customer_Name" placeholder="请输入客户名称..."></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" label-colon
          class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24"
          v-if="Role !== '销售员'">
      <FormItem :label-width="80" label="销售员">
            <Select v-model="formItem.SalespersonID"
                      value="formItem.SalespersonName"
                      :label-in-value="true"
                      @on-change="SalespersonHandleClick"
                      clearable
                      filterable>
                        <Option :value="item.UserID" v-for="item of SalespersonList" :key="item.UserID">{{item.UserName}}</Option>
                      </Select>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" label-colon
           v-if="formItem.switch === '收起'" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="收货地址">
            <Input v-model="formItem.Address" placeholder="请输入收货地址..."></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" label-colon
          v-if="formItem.switch === '收起'" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="收货人">
            <Input v-model="formItem.Contacts" placeholder="请输入收货人..."></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" label-colon
          v-if="formItem.switch === '收起'" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="收货电话">
            <Input v-model="formItem.Telephone" placeholder="请输入收货电话..."></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem>
        <div style="float:right">
          <Button type="primary" style="margin-right:1rem" @click="QueryHandleClick">查询</Button>
          <Button style="margin-right:1rem" @click="ResetHandleClick">重置</Button>
          <a href="#" @click.prevent="changeLimit">
            {{formItem.switch}}
            <Icon v-if="formItem.switch === '展开'" type="ios-arrow-down" />
            <Icon v-if="formItem.switch === '收起'" type="ios-arrow-up" />
          </a>
        </div>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import { GetSalespersonListApi } from '../../../../api/Customer'
export default {
  name: 'OrderHomeHeader',
  data () {
    return {
      formItem: {
        OrderID: '',
        State: '',
        Address: '',
        Contacts: '',
        Telephone: '',
        SalespersonID: '',
        SalespersonName: '',
        Customer_Name: '',
        isAssign: '',
        switch: '展开'
      },
      SalespersonList: [],
      Role: ''
    }
  },
  mounted: function () {
    this.Role = this.$store.state.userInfo.roleName
    this.GetSalespersonList()
  },
  methods: {
    // 获取销售人员数据
    GetSalespersonList () {
      GetSalespersonListApi().then(res => {
        if (res.IsSuccess) {
          this.SalespersonList = res.Data
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 销售人员选择后回调
    SalespersonHandleClick (value) {
      this.formItem.SalespersonID = value.value
      this.formItem.SalespersonName = value.label
    },
    changeLimit () {
      if (this.formItem.switch === '展开') {
        this.formItem.switch = '收起'
      } else { this.formItem.switch = '展开' }
    },
    // 重置点击事件
    ResetHandleClick () {
      this.formItem = {
        OrderID: '',
        State: '',
        Address: '',
        Contacts: '',
        Telephone: '',
        SalespersonID: '',
        SalespersonName: '',
        Customer_Name: '',
        isAssign: '',
        switch: this.formItem.switch
      }
      this.$emit('ResetHandleClick')
    },
    // 点击查询按钮事件回调
    QueryHandleClick () {
      let check = false
      if (this.formItem.OrderID !== '') {
        check = true
      } else if (this.formItem.State !== '') {
        check = true
      } else if (this.formItem.Address !== '') {
        check = true
      } else if (this.formItem.Contacts) {
        check = true
      } else if (this.formItem.Telephone !== '') {
        check = true
      } else if (this.formItem.SalespersonID !== '') {
        check = true
      } else if (this.formItem.Customer_Name !== '') {
        check = true
      } else if (this.formItem.isAssign !== '') {
        check = true
      }
      if (check) {
        this.$emit('QueryHandleClick', this.formItem)
      } else {
        this.$Modal.error({
          title: '请填写需要查询的条件',
          content: '请填写需要查询的条件'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@media (min-width: 576px) {
  .ivu-col-span-sm-24 {
    display: block;
    width: 100%;
  }
}
@media (min-width: 576px) {
  .ivu-col-span-xl-24 {
    float: left;
    flex: 0 0 auto;
  }
}
@media (min-width: 768px) {
    .ivu-col-span-md-12 {
      display: block;
      width: 50%;
   }
}
@media (min-width: 768px) {
  .ivu-col-span-xl-12 {
    float: left;
    flex: 0 0 auto;
  }
}
@media (min-width: 1200px) {
  .ivu-col-span-xl-8 {
    display: block;
    width: 33.33333333%;
   }
}
@media (min-width: 1200px) {
  .ivu-col-span-xl-8 {
    float: left;
    flex: 0 0 auto;
  }
}
.ivu-row-flex-end {
    justify-content: flex-end;
}
.ivu-row-flex {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
</style>
